import breakService from '../../services/breakService';

const state = {
  breaks: []
};

const getters = {
  allBreaks: state => state.breaks
};

const actions = {
  async fetchBreaks({ commit }, filters = {}) {
    try {
      console.log('Fetching breaks with filters:', filters);
      const response = await breakService.getBreaks(filters);
      console.log('Store received response:', response);
      commit('setBreaks', response.data.data);
    } catch (error) {
      console.error('Store error:', error);
      commit('setBreaks', []);
    }
  },

  async addBreak({ commit }, breakData) {
    const response = await breakService.addBreak(breakData);
    commit('newBreak', response.data);
  },

  async updateBreak({ commit }, breakData) {
    const response = await breakService.updateBreak(breakData.id, breakData);
    commit('updateBreak', response.data);
  },

  async deleteBreak({ commit }, breakId) {
    await breakService.deleteBreak(breakId);
    commit('removeBreak', breakId);
  }
};

const mutations = {
  setBreaks: (state, breaks) => {
    state.breaks = breaks || [];
  },
  newBreak: (state, breakData) => state.breaks.push(breakData),
  updateBreak: (state, updatedBreak) => {
    const index = state.breaks.findIndex(b => b.id === updatedBreak.id);
    if (index !== -1) {
      state.breaks.splice(index, 1, updatedBreak);
    }
  },
  removeBreak: (state, breakId) => {
    state.breaks = state.breaks.filter(b => b.id !== breakId);
  }
};

export default {
  state,
  getters,
  actions,
  mutations
}; 